import React, { useEffect, useState } from 'react';
import i18n from '@/utils/i18n';
import { LayoutStoreInstance } from '../../LayoutStore';
import { ContainerStationReducedFragment } from '../../graphql/fragments/containerStationReduced.generated';
import ContainerStationsList, {
  CONTAINER_STATION_PAGE_SIZE,
} from '../../components/ContainerStationList';
import { Communicator } from '../../tools/Communication';
import { useStoreContainerStationsPaginatedQuery } from '../../graphql/queries/containerStationsForStorePaginated.generated';
import { ContentSection } from '../../components/Layout/ContentSection';

type StoreContainerStationsListProps = {
  storeTextId: string;
  storeUuid: string;
  title: string;
};

export function StoreContainerStationsList(
  props: StoreContainerStationsListProps,
) {
  const [containerStations, setContainerStations] = useState<
    ContainerStationReducedFragment[]
  >([]);
  const [defaultStockUserId, setDefaultStockUserId] = useState<string | null>(
    null,
  );
  const [defaultStockerUserLoading, setDefaultStockerUserLoading] =
    useState(true);
  const [total, setTotal] = useState<number>(0);

  const { data, loading, error, refetch } =
    useStoreContainerStationsPaginatedQuery({
      variables: {
        store_id: props.storeTextId,
        skip: 0,
        take: CONTAINER_STATION_PAGE_SIZE,
      },
    });

  useEffect(() => {
    if (data) {
      if (data?.storeContainerStationsPaginated != null) {
        setContainerStations(
          data?.storeContainerStationsPaginated.container_stations,
        );
        setTotal(data?.storeContainerStationsPaginated.total);
      }
    }
  }, [data]);

  const { storeUuid } = props;
  useEffect(() => {
    (async () => {
      if (props.storeUuid) {
        try {
          const res = await Communicator.Get(
            '/Merchant/GetDefaultStockUserId',
            { storeId: encodeURIComponent(storeUuid) },
          );
          const body = await res.json();
          setDefaultStockUserId(body);
        } catch (e: any) {}
      }
      setDefaultStockerUserLoading(false);
    })();
  }, [storeUuid]);

  if (error) {
    LayoutStoreInstance.setError(i18n.t('ContainerStation:errorLoading'));
  }

  if (!loading && defaultStockUserId == null) {
    return <p>{i18n.t('ContainerStation:defaultStockUserNotSet')}</p>;
  }

  return (
    <ContentSection title={props.title} collapsable={false} key="content">
      <ContainerStationsList
        containerStations={containerStations}
        loading={loading}
        loadMore={(skip, take) => {
          refetch({ skip, take });
        }}
        total={total}
        storeTextId={props.storeTextId}
        onClick={() => {}}
      />
    </ContentSection>
  );
}

export default StoreContainerStationsList;
